import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './NewSucursal.css';
import baseURL from '../../url';

export default function NewSucursal() {
    const [nombre, setNombre] = useState('');
    const [url, setUrl] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validaciones
        if (!nombre.trim() || !url.trim()) {
            toast.error('Todos los campos son obligatorios');
            return;
        }

        // Validar formato de URL
        try {
            new URL(url);
        } catch (error) {
            toast.error('La URL no es válida. Debe incluir http:// o https://');
            return;
        }

        const formData = new FormData();
        formData.append('nombre', nombre);
        formData.append('url', url);

        fetch(`${baseURL}/sucursalesPost.php`, {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    toast.error(data.error);
                } else {
                    toast.success(data.mensaje);
                    setNombre('');
                    setUrl('');
                    // Recargar la página para actualizar la lista
                    setTimeout(() => {
                        window.location.reload();
                    }, 1500);
                }
            })
            .catch(error => {
                console.error('Error:', error);
                toast.error('Error al crear la sucursal');
            });
    };

    return (
        <div className='NewSucursalContain'>
            <ToastContainer />
            <form className='formSucursal' onSubmit={handleSubmit}>
                <h2>Agregar Nueva Sucursal</h2>
                <fieldset>
                    <legend>Nombre de la Sucursal</legend>
                    <input
                        type="text"
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                        placeholder="Ej: México, Lima Centro, Bogotá Norte..."
                        required
                    />
                </fieldset>
                <fieldset>
                    <legend>URL de la Sucursal</legend>
                    <input
                        type="url"
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                        placeholder="https://ejemplo.com/sucursal"
                        required
                    />
                    <small style={{color: '#666', fontSize: '12px', marginTop: '5px', display: 'block'}}>
                        La URL debe ser completa, incluyendo http:// o https://
                    </small>
                </fieldset>
                <button type="submit" className='btnPost'>
                    Agregar Sucursal
                </button>
            </form>
        </div>
    );
}



